import { hideScrollBar } from '@repo/ui/components/utilities';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const Wrapper = styled(FlexRow)`
  align-items: center;
  gap: 16px;
  justify-content: flex-start;
  padding: 20px 15px 10px 15px;
  border-bottom: 1px solid ${themeStyle.varInkLight};
  overflow-x: scroll;
  white-space: nowrap;
  ${hideScrollBar};

  ${QUERIES.tabletAndUp} {
    padding: 12px 0;
  }
`;
